export default __webpack_public_path__ + "static/media/step_ok.7aff6dd4.svg";